import { c as _c } from "react/compiler-runtime";
import { OutsideLink } from "@/components/OutsideLink";
import { GithubOutlined, LinkOutlined, ZhihuCircleFilled } from "@ant-design/icons";
import React from "react";
import { defaultLocale, type Locale } from "@/i18n/routing";
export type ExperienceNoteKey = "mininggoat" | "risingwave" | "pingcap" | "phd" | "master" | "bachelor" | "wspc";
export function experienceNoteFor(locale: Locale, key: ExperienceNoteKey): React.ReactNode {
  switch (key) {
    case "mininggoat":
      return <MininggoatNote locale={locale} />;
    case "risingwave":
      return <RisingWaveNote locale={locale} />;
    case "pingcap":
      return <PingcapNote locale={locale} />;
    case "phd":
      return <PhdNote locale={locale} />;
    case "master":
      return <MasterNote locale={locale} />;
    case "bachelor":
      return <BachelorNote locale={locale} />;
    case "wspc":
      return <WspcNote locale={locale} />;
  }
}
function MininggoatNote(t0) {
  const $ = _c(6);
  const {
    locale
  } = t0;
  if (locale === "zh-Hans") {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <LinkOutlined />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <ul><li>主要负责挖数羊智能数据交易平台 {t1}{" "}<OutsideLink href="https://washuyang.com/" />{" "}的前端开发与系统运维工作，包括平台前端功能开发、页面优化、系统维护及相关技术支持等。</li><li>使用 React、Next.js 等技术栈，结合 Cursor、Grok、OpenCode（DeepSeek） 等 AI Coding 工具加速开发。</li></ul>;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    return t2;
  }
  if (locale === "zh-Hant") {
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <LinkOutlined />;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <ul><li>主要負責挖數羊智慧資料交易平台 {t1}{" "}<OutsideLink href="https://washuyang.com/" />{" "}的前端開發與系統維運工作，包括平臺前端功能開發、頁面最佳化、系統維護及相關技術支援等。</li><li>使用 React、Next.js 等技術棧，結合 Cursor、Grok、OpenCode（DeepSeek） 等 AI Coding 工具加速開發。</li></ul>;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    return t2;
  }
  let t1;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <LinkOutlined data-sentry-element="LinkOutlined" data-sentry-source-file="experienceNotes.tsx" />;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ul data-sentry-component="MininggoatNote" data-sentry-source-file="experienceNotes.tsx"><li>Responsible for frontend development and system operations for the Mininggoat intelligent data trading platform (Washuyang){" "}{t1} <OutsideLink href="https://washuyang.com/" data-sentry-element="OutsideLink" data-sentry-source-file="experienceNotes.tsx" />, including frontend feature development, page optimization, system maintenance and technical support.</li><li>Accelerated development with React and Next.js, together with AI coding tools such as Cursor, Grok and OpenCode (DeepSeek).</li></ul>;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}
function RisingWaveNote(t0) {
  const $ = _c(6);
  const {
    locale
  } = t0;
  if (locale === "zh-Hans") {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <LinkOutlined />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <ul><li>开发与维护官方网站 {t1}{" "}<OutsideLink href="https://risingwave.com/" /> ：维护旧版官网，对原有 WordPress 主题做二次开发，并新开发 WordPress 插件与模板。</li><li>开发新版官网，将站点从旧版 WordPress 迁移至 React.js 与 Next.js 技术栈。</li></ul>;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    return t2;
  }
  if (locale === "zh-Hant") {
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <LinkOutlined />;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <ul><li>開發與維護官方網站 {t1}{" "}<OutsideLink href="https://risingwave.com/" /> ：維護舊版官網，對原有 WordPress 主題做二次開發，並新開發 WordPress 外掛與範本。</li><li>開發新版官網，將網站從舊版 WordPress 遷移至 React.js 與 Next.js 技術棧。</li></ul>;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    return t2;
  }
  let t1;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <LinkOutlined data-sentry-element="LinkOutlined" data-sentry-source-file="experienceNotes.tsx" />;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ul data-sentry-component="RisingWaveNote" data-sentry-source-file="experienceNotes.tsx"><li>Develop and maintain the official website {t1}{" "}<OutsideLink href="https://risingwave.com/" data-sentry-element="OutsideLink" data-sentry-source-file="experienceNotes.tsx" /> — maintained the legacy WordPress site by extending its existing theme, and built new WordPress plugins and templates.</li><li>Rebuilt the website on React.js and Next.js, migrating it away from the legacy WordPress stack.</li></ul>;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}
function PingcapNote(t0) {
  const $ = _c(24);
  const {
    locale
  } = t0;
  if (locale === "zh-Hans") {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <LinkOutlined />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <OutsideLink href="https://tidb.net/" />;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <GithubOutlined />;
      $[2] = t3;
    } else {
      t3 = $[2];
    }
    let t4;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <li>从零开发 TiDB 中文社区官网 {t1}{" "}{t2}，使用 React.js 与 Next.js 技术栈。 其为源码可得项目，GitHub 仓库为{" "}{t3}{" "}<OutsideLink href="https://github.com/pingcap-inc/tidb.io" /></li>;
      $[3] = t4;
    } else {
      t4 = $[3];
    }
    let t5;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <LinkOutlined />;
      $[4] = t5;
    } else {
      t5 = $[4];
    }
    let t6;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <li>开发 PingCAP 新版中文官网 {t5}{" "}<OutsideLink href="https://cn.pingcap.com/" /> ，从旧版 Hugo 框架迁移至 React.js 与 Gatsby.js 技术栈。</li>;
      $[5] = t6;
    } else {
      t6 = $[5];
    }
    let t7;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = <LinkOutlined />;
      $[6] = t7;
    } else {
      t7 = $[6];
    }
    let t8;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = <ul>{t4}{t6}<li>从零开始使用 Next.js 构建平凯星辰公司官网 {t7}{" "}<OutsideLink href="https://pingcap.cn/" /> 。</li></ul>;
      $[7] = t8;
    } else {
      t8 = $[7];
    }
    return t8;
  }
  if (locale === "zh-Hant") {
    let t1;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <LinkOutlined />;
      $[8] = t1;
    } else {
      t1 = $[8];
    }
    let t2;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <OutsideLink href="https://tidb.net/" />;
      $[9] = t2;
    } else {
      t2 = $[9];
    }
    let t3;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <GithubOutlined />;
      $[10] = t3;
    } else {
      t3 = $[10];
    }
    let t4;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <li>從零開發 TiDB 中文社群官網 {t1}{" "}{t2}，使用 React.js 與 Next.js 技術棧。 其為原始碼可得專案，GitHub 儲存庫為 {t3}{" "}<OutsideLink href="https://github.com/pingcap-inc/tidb.io" /></li>;
      $[11] = t4;
    } else {
      t4 = $[11];
    }
    let t5;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <LinkOutlined />;
      $[12] = t5;
    } else {
      t5 = $[12];
    }
    let t6;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <li>開發 PingCAP 新版中文官網 {t5}{" "}<OutsideLink href="https://cn.pingcap.com/" /> ，從舊版 Hugo 框架遷移至 React.js 與 Gatsby.js 技術棧。</li>;
      $[13] = t6;
    } else {
      t6 = $[13];
    }
    let t7;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = <LinkOutlined />;
      $[14] = t7;
    } else {
      t7 = $[14];
    }
    let t8;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = <ul>{t4}{t6}<li>從零開始使用 Next.js 建構平凱星辰公司官網 {t7}{" "}<OutsideLink href="https://pingcap.cn/" /> 。</li></ul>;
      $[15] = t8;
    } else {
      t8 = $[15];
    }
    return t8;
  }
  let t1;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <LinkOutlined data-sentry-element="LinkOutlined" data-sentry-source-file="experienceNotes.tsx" />;
    $[16] = t1;
  } else {
    t1 = $[16];
  }
  let t2;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <OutsideLink href="https://tidb.net/" data-sentry-element="OutsideLink" data-sentry-source-file="experienceNotes.tsx" />;
    $[17] = t2;
  } else {
    t2 = $[17];
  }
  let t3;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <GithubOutlined data-sentry-element="GithubOutlined" data-sentry-source-file="experienceNotes.tsx" />;
    $[18] = t3;
  } else {
    t3 = $[18];
  }
  let t4;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <li>Built the TiDB Chinese community website {t1}{" "}{t2} from scratch with React.js and Next.js. It is a source-available project — GitHub repository:{" "}{t3}{" "}<OutsideLink href="https://github.com/pingcap-inc/tidb.io" data-sentry-element="OutsideLink" data-sentry-source-file="experienceNotes.tsx" /></li>;
    $[19] = t4;
  } else {
    t4 = $[19];
  }
  let t5;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <LinkOutlined data-sentry-element="LinkOutlined" data-sentry-source-file="experienceNotes.tsx" />;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  let t6;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <li>Built PingCAP's new Chinese official website {t5}{" "}<OutsideLink href="https://cn.pingcap.com/" data-sentry-element="OutsideLink" data-sentry-source-file="experienceNotes.tsx" /> , migrating it from the legacy Hugo framework to React.js and Gatsby.js.</li>;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  let t7;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <LinkOutlined data-sentry-element="LinkOutlined" data-sentry-source-file="experienceNotes.tsx" />;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <ul data-sentry-component="PingcapNote" data-sentry-source-file="experienceNotes.tsx">{t4}{t6}<li>Built PingCAP's corporate website {t7}{" "}<OutsideLink href="https://pingcap.cn/" data-sentry-element="OutsideLink" data-sentry-source-file="experienceNotes.tsx" /> from scratch with Next.js.</li></ul>;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  return t8;
}
function PhdNote(t0) {
  const $ = _c(3);
  const {
    locale
  } = t0;
  if (locale === "zh-Hans") {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <ul><li>研究助理，关注教育与 AI 融合相关主题。（技术栈：Dify + Next.js）。</li></ul>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  if (locale === "zh-Hant") {
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <ul><li>研究助理，關注教育與 AI 融合相關主題。（技術棧：Dify + Next.js）。</li></ul>;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ul data-sentry-component="PhdNote" data-sentry-source-file="experienceNotes.tsx"><li>Research Assistant, focusing on topics related to the integration of Education and AI. (Technology stack: Dify + Next.js).</li></ul>;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
function MasterNote(t0) {
  const $ = _c(3);
  const {
    locale
  } = t0;
  if (locale === "zh-Hans") {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <ul><li>光电及半导体组。研究使用变容二极管（PIN 二极管）与液晶（LC）构建 FSS（频率选择表面）与微波开关。</li><li>研究基于 PCB 电路板、半导体元件与各种新型材料，设计毫米波空间滤波器／天线。</li><li>电子系统组。研究优化 5GC（第五代核心网）。阅读 3GPP 规范以寻找增强／优化 5G 电信网络协议的方向。</li><li>获校级奖学金。</li></ul>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  if (locale === "zh-Hant") {
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <ul><li>光電與半導體組。研究使用變容二極體（PIN 二極體）與液晶（LC）建構 FSS（頻率選擇表面）與微波開關。</li><li>研究以 PCB 電路板、半導體元件與各種新型材料，設計毫米波空間濾波器／天線。</li><li>系統組。研究最佳化 5GC（第五代核心網）。閱讀 3GPP 規範以尋找增強／最佳化 5G 電信網路協定的方向。</li><li>獲校級獎學金。</li></ul>;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ul data-sentry-component="MasterNote" data-sentry-source-file="experienceNotes.tsx"><li>Group of Optoelectronics and Semiconductors. Research to build FSS(Frequency Selective Surface) and Microwave-Switch using Varactor Diode(Pin Diode) and LC(Liquid Crystal).</li><li>Research on designing millimeter-wave spatial filters and antennas based on PCB circuits, semiconductor devices and novel materials.</li><li>Group of Electronic System. Research to optimize 5GC(5th-generation core network). Reading 3GPP specification to find the point of enhance/optimize the protocol of 5G telecommunication network.</li><li>Awarded a university-level scholarship.</li></ul>;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
const ZHIHU_TITLES: Record<Locale, [string, string, string, string, string]> = {
  "en-US": ["Writing an OS from scratch (1) — Basic concepts", "Writing an OS from scratch (2) — startup & bootloader", "Writing an OS from scratch (3) — Task switcher", "Writing an OS from scratch (4) — When to switch tasks", "Writing an OS from scratch (5) — Putting programs to sleep"],
  "zh-Hans": ["从零开始写一个操作系统（一） —— 基本概念", "从零开始写一个操作系统（二） —— startup 与 bootloader", "从零开始写一个操作系统（三） —— 任务切换器", "从零开始写一个操作系统（四） —— 任务切换的时机", "从零开始写一个操作系统（五） —— 让程序睡一会儿"],
  "zh-Hant": ["從零開始寫一個作業系統（一） —— 基本概念", "從零開始寫一個作業系統（二） —— startup 與 bootloader", "從零開始寫一個作業系統（三） —— 工作切換器", "從零開始寫一個作業系統（四） —— 工作切換的時機", "從零開始寫一個作業系統（五） —— 讓程式睡一會兒"]
};
function BachelorNote(t0) {
  const $ = _c(37);
  const {
    locale
  } = t0;
  const z = ZHIHU_TITLES[locale] ?? ZHIHU_TITLES[defaultLocale];
  const osIntro = locale === "zh-Hans" ? "\u4F7F\u7528 C \u4E0E ARM Cortex-M3 \u6C47\u7F16\u8BED\u8A00\u7F16\u5199\u7684\u5B9E\u65F6\u64CD\u4F5C\u7CFB\u7EDF\uFF0C" : locale === "zh-Hant" ? "\u4F7F\u7528 C \u8207 ARM Cortex-M3 \u7D44\u5408\u8A9E\u8A00\u64B0\u5BEB\u7684\u5373\u6642\u4F5C\u696D\u7CFB\u7D71\uFF0C" : "A real-time OS written by C and ARM Cortex-M3 assembly language, ";
  const isa = locale === "zh-Hans" ? "\u67E5\u9605 ISA\uFF08\u6307\u4EE4\u96C6\u67B6\u6784\uFF09\u89C4\u8303\uFF08RISC-V\u3001Intel IA-32/x86-64\uFF09\uFF0C\u786E\u8BA4\u5404\u6307\u4EE4\u884C\u4E3A\u7EC6\u8282\u540E\u4EE5 VerilogHDL/SystemVerilogHDL \u5B9E\u73B0\u5E76\u90E8\u7F72\u4E8E FPGA\u3002" : locale === "zh-Hant" ? "\u67E5\u95B1 ISA\uFF08\u6307\u4EE4\u96C6\u67B6\u69CB\uFF09\u898F\u7BC4\uFF08RISC-V\u3001Intel IA-32/x86-64\uFF09\uFF0C\u78BA\u8A8D\u5404\u6307\u4EE4\u884C\u70BA\u7D30\u7BC0\u5F8C\u4EE5 VerilogHDL/SystemVerilogHDL \u5BE6\u4F5C\u4E26\u90E8\u7F72\u65BC FPGA\u3002" : "Retrieve ISA(instruction set architecture) specifications (RISC-V, Intel IA-32/x86-64), confirm each instructions operation's detail then implement it by VerilogHDL/SystemVerilogHDL and build it on FPGA.";
  const net = locale === "zh-Hans" ? "\u67E5\u9605\u7F51\u7EDC\u534F\u8BAE\u89C4\u8303\uFF08RFC\u3001IEEE \u7B49\uFF09\uFF0C\u5E76\u4EE5\u7F16\u7A0B\u8BED\u8A00\u5B9E\u73B0\u3002" : locale === "zh-Hant" ? "\u67E5\u95B1\u7DB2\u8DEF\u5354\u5B9A\u898F\u7BC4\uFF08RFC\u3001IEEE \u7B49\uFF09\uFF0C\u4E26\u4EE5\u7A0B\u5F0F\u8A9E\u8A00\u5BE6\u4F5C\u3002" : "Retrieve the network protocol specifications (RFC, IEEE, etc.), implement it by programming language.";
  const dig = locale === "zh-Hans" ? "\u6570\u5B57\u7535\u8DEF\u3001MCU\uFF08\u5FAE\u63A7\u5236\u5668\uFF09\u3001FPGA\uFF08\u73B0\u573A\u53EF\u7F16\u7A0B\u95E8\u9635\u5217\uFF09\u3001PCB \u5E03\u7EBF\uFF0C\u4F7F\u7528\u6C47\u7F16\u4E0E C/C++ \u7684\u5D4C\u5165\u5F0F\u7CFB\u7EDF\u5F00\u53D1\u3002" : locale === "zh-Hant" ? "\u6578\u4F4D\u96FB\u8DEF\u3001MCU\uFF08\u5FAE\u63A7\u5236\u5668\uFF09\u3001FPGA\uFF08\u73FE\u5834\u53EF\u7A0B\u5F0F\u5316\u908F\u8F2F\u9598\u9663\u5217\uFF09\u3001PCB \u4F48\u7DDA\uFF0C\u4F7F\u7528\u7D44\u5408\u8A9E\u8A00\u8207 C/C++ \u7684\u5D4C\u5165\u5F0F\u7CFB\u7D71\u958B\u767C\u3002" : "Digital Circuit, MCU(Microcontroller Unit), FPGA(Field Programmable Gate Array), PCB(Printed Circuit Board) layout, embedded system development using ASM(assembly language) and C/C++.";
  const capstone = locale === "zh-Hans" ? "\u6BD5\u4E1A\u8BBE\u8BA1\uFF1A\u4F7F\u7528 VerilogHDL \u5728 FPGA \u4E0A\u6784\u5EFA RISC-V \u6307\u4EE4\u96C6\u67B6\u6784\u7684 CPU\u3002" : locale === "zh-Hant" ? "\u7562\u696D\u5C08\u984C\uFF1A\u4F7F\u7528 VerilogHDL \u65BC FPGA \u4E0A\u5EFA\u69CB RISC-V \u6307\u4EE4\u96C6\u67B6\u69CB\u7684 CPU\u3002" : "Capstone project: built a RISC-V instruction set architecture CPU on an FPGA using Verilog HDL.";
  const award = locale === "zh-Hans" ? "\u83B7\u4E66\u5377\u5956\uFF08\u73ED\u7EA7\u6392\u540D\u7B2C\u4E00\uFF09\u3002" : locale === "zh-Hant" ? "\u7372\u66F8\u5377\u734E\uFF08\u73ED\u7D1A\u6392\u540D\u7B2C\u4E00\uFF09\u3002" : "Awarded the Academic Excellence Award (ranked first in the class).";
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["https://zhuanlan.zhihu.com/p/350587132", "https://zhuanlan.zhihu.com/p/350627431", "https://zhuanlan.zhihu.com/p/350625869", "https://zhuanlan.zhihu.com/p/351781211", "https://zhuanlan.zhihu.com/p/361465834"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const urls = t1;
  let t2;
  if ($[1] !== capstone) {
    t2 = <li>{capstone}</li>;
    $[1] = capstone;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <GithubOutlined data-sentry-element="GithubOutlined" data-sentry-source-file="experienceNotes.tsx" />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <OutsideLink href="https://github.com/cw1997/ez-rtos" data-sentry-element="OutsideLink" data-sentry-source-file="experienceNotes.tsx" />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== osIntro) {
    t5 = <li>{osIntro}{t3}{" "}{t4}</li>;
    $[5] = osIntro;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== z) {
    t6 = urls.map((href, i) => <li key={href}><ZhihuCircleFilled />{" "}<OutsideLink href={href}>{z[i]}</OutsideLink></li>);
    $[7] = z;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t5 || $[10] !== t6) {
    t7 = <ul>{t5}{t6}</ul>;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== dig || $[13] !== t7) {
    t8 = <li>{dig}{t7}</li>;
    $[12] = dig;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <GithubOutlined data-sentry-element="GithubOutlined" data-sentry-source-file="experienceNotes.tsx" />;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  let t11;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <li>{t9}{" "}<OutsideLink href="https://github.com/risc-v-cpu" data-sentry-element="OutsideLink" data-sentry-source-file="experienceNotes.tsx" /></li>;
    t11 = <GithubOutlined data-sentry-element="GithubOutlined" data-sentry-source-file="experienceNotes.tsx" />;
    $[16] = t10;
    $[17] = t11;
  } else {
    t10 = $[16];
    t11 = $[17];
  }
  let t12;
  let t13;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <li>{t11}{" "}<OutsideLink href="https://github.com/cw1997/SDRAM-Controller" data-sentry-element="OutsideLink" data-sentry-source-file="experienceNotes.tsx" /></li>;
    t13 = <GithubOutlined data-sentry-element="GithubOutlined" data-sentry-source-file="experienceNotes.tsx" />;
    $[18] = t12;
    $[19] = t13;
  } else {
    t12 = $[18];
    t13 = $[19];
  }
  let t14;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <ul>{t10}{t12}<li>{t13} <OutsideLink href="https://github.com/openx86" data-sentry-element="OutsideLink" data-sentry-source-file="experienceNotes.tsx" /></li></ul>;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] !== isa) {
    t15 = <li>{isa}{t14}</li>;
    $[21] = isa;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <GithubOutlined data-sentry-element="GithubOutlined" data-sentry-source-file="experienceNotes.tsx" />;
    $[23] = t16;
  } else {
    t16 = $[23];
  }
  let t17;
  let t18;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <li>{t16}{" "}<OutsideLink href="https://github.com/cw1997/inetutils" data-sentry-element="OutsideLink" data-sentry-source-file="experienceNotes.tsx" /></li>;
    t18 = <GithubOutlined data-sentry-element="GithubOutlined" data-sentry-source-file="experienceNotes.tsx" />;
    $[24] = t17;
    $[25] = t18;
  } else {
    t17 = $[24];
    t18 = $[25];
  }
  let t19;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <ul>{t17}<li>{t18}{" "}<OutsideLink href="https://github.com/cw1997/ez-mysql/tree/develop" data-sentry-element="OutsideLink" data-sentry-source-file="experienceNotes.tsx" /></li></ul>;
    $[26] = t19;
  } else {
    t19 = $[26];
  }
  let t20;
  if ($[27] !== net) {
    t20 = <li>{net}{t19}</li>;
    $[27] = net;
    $[28] = t20;
  } else {
    t20 = $[28];
  }
  let t21;
  if ($[29] !== award) {
    t21 = <li>{award}</li>;
    $[29] = award;
    $[30] = t21;
  } else {
    t21 = $[30];
  }
  let t22;
  if ($[31] !== t15 || $[32] !== t2 || $[33] !== t20 || $[34] !== t21 || $[35] !== t8) {
    t22 = <ul data-sentry-component="BachelorNote" data-sentry-source-file="experienceNotes.tsx">{t2}{t8}{t15}{t20}{t21}</ul>;
    $[31] = t15;
    $[32] = t2;
    $[33] = t20;
    $[34] = t21;
    $[35] = t8;
    $[36] = t22;
  } else {
    t22 = $[36];
  }
  return t22;
}
function WspcNote(t0) {
  const $ = _c(3);
  const {
    locale
  } = t0;
  if (locale === "zh-Hans") {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <ul><li>主要学习 Java／PHP 等 Web 前后端开发相关技术。Web 后端包括 Java 平台（JSP、Servlet、Spring 与 Spring MVC、Mybatis、Hibernate）、Microsoft.NET 平台（ASP.NET WebForm 与 ASP.NET MVC）、PHP（Laravel）、Python（Flask）、Golang（Beego、gin）</li><li>Web 前端开发，包括 jQuery、Vue.js、React</li><li>担任班级学习委员，负责班级助教工作。获校级奖学金。</li></ul>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  if (locale === "zh-Hant") {
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <ul><li>主要學習 Java／PHP 等 Web 前後端開發相關技術。Web 後端包括 Java 平臺（JSP、Servlet、Spring 與 Spring MVC、Mybatis、Hibernate）、Microsoft.NET 平臺（ASP.NET WebForm 與 ASP.NET MVC）、PHP（Laravel）、Python（Flask）、Golang（Beego、gin）</li><li>Web 前端開發，包括 jQuery、Vue.js、React</li><li>擔任班級學習委員，負責班級助教工作。獲校級獎學金。</li></ul>;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ul data-sentry-component="WspcNote" data-sentry-source-file="experienceNotes.tsx"><li>{"Focused on Java/PHP and other web frontend and backend development technologies. Backend work included the Java platform (JSP(Java Server Pages), Servlet, Spring framework & Spring MVC & Mybatis & Hibernate), Microsoft.NET platform (ASP.NET WebForm & ASP.NET MVC), PHP (Laravel), Python (Flask), Golang (Beego, gin)"}</li><li>Web frontend development, including jQuery, Vue.js, React</li><li>Served as the class study committee member and assisted with class teaching activities. Awarded a university-level scholarship.</li></ul>;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}